import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

// Shown right after login when the backend reports must_change_password=true
// on a staff/admin account that was just created with a one-time password
// (see UsersController::actionCreateUser in bigcitytrade3_hubadminapi) - the
// user cannot leave this screen until they set their own password.
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  form: any;
  submitted = false;
  errorMessage = '';

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    private toast: ToastClientService,
  ) {
    this.form = this.formBuilder.group({
      new_password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      confirm_password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
    });
  }

  ngOnInit() {
    // 'login' in localStorage is only ever set by AuthGuardService the first
    // time a guarded route runs, which hasn't happened yet on a fresh
    // redirect straight from login - check the actual saved token instead.
    if (!localStorage.getItem('auth-token')) {
      this.router.navigateByUrl('/signin');
    }
  }

  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;
    this.errorMessage = '';
    if (this.form.invalid) {
      return;
    }
    if (this.f.new_password.value !== this.f.confirm_password.value) {
      this.errorMessage = 'Passwords do not match';
      return;
    }

    // Must stay a plain object, not JSON.stringify'd - see the comment on the
    // equivalent call in admin-users.component.ts for why.
    this.apiService.post(this.apiConfig.changePassword, { new_password: this.f.new_password.value })
      .subscribe((res: any) => {
        this.toast.Success('Password updated successfully');
        this.router.navigateByUrl('/hubAdmin/dashboard');
      }, err => {
        this.errorMessage = (err && err.data && err.data.message) ? err.data.message : 'Failed to update password';
      });
  }
}
